import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getDashboardData = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `dashboard${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch bookings");
    return error;
  }
};